export default __webpack_public_path__ + "static/hero-bg-left-2f3ff7dba437bb2d5d8bd8a587ab0bbd.png";